export default __webpack_public_path__ + "static/media/open-tender-logo-white_1280x172.c74cda91.png";